<template>
  <div>
    <div class="style-news-headers" v-if="gallery">
      <div class="stnh-wide">
        <h3>{{ gallery.name }} <span class="lc">{{ $nippets.animators }}</span></h3>
      </div>
      <div class="flex-start">
        <h3>{{ $nippets.homeAnim.latestNews }}</h3>
        <ix-router-link to="/news" class="smallbutton">{{ $nippets.homeAnim.seeAll }}</ix-router-link>
      </div>
    </div>
    <div class="style-news-area">
      <div v-for="item in items" :key="item.key">
        <template v-if="item.style">
          <style-image :artistData="item.data" v-on:click="goPortfolio" v-on:zoom="showZoomPortfolio" />
        </template>
        <template v-else>
          <news-panel :item="item.data" ingrid v-on:click="goStory" />
        </template>
      </div>
    </div>
    <div class="style-news-headers pt-16" v-if="gallery">
      <div class="stnh-wide">
        <ix-router-link class="bigbutton" :to="gallery.url" v-if="galStyleLink">{{ galStyleLink }}</ix-router-link>
      </div>
      <div class="t-right">
        <ix-router-link to="/animation-commissioning" class="bigbutton green">{{ $nippets.ourGuide }}</ix-router-link>
      </div>
    </div>
    <zoom-image :visible="showZoom" v-on:prev="zoomImage(-1)" v-on:next="zoomImage(1)"
          :image="selImage" v-on:close="closeZoom" :artist="artist" />
  </div>
</template>

<script>
import StyleImage from '@/components/widgets/StyleAnimNew.vue'
import NewsPanel from '@/views/news/NewsPanel.vue'
import ZoomImage from '@/components/panels/ZoomImage.vue'

export default {
  components: {
    StyleImage,
    NewsPanel,
    ZoomImage
  },
  props: {
    gallery: Object
  },
  data () {
    return {
      loaded: false,
      items:[],
      tag: 'animation',
      showZoom: false,
      selImage: null,
      galleryData: null,
      artist: null,
      galStyleLink: null
    }
  },
  methods: {
    getCurrentPos: function () {
      if(!this.artist) return -1
      if(!this.artist.artist_id) return -1
      return this.galleryData.findIndex(el => el.artist_id === this.artist.artist_id)
    },
    zoomImage: async function (moveRel) {
      let pos = this.getCurrentPos()
      //console.log('pos is ' + pos)
      if(pos < 0) {
        pos = 0
      }
      else {
        pos += moveRel
        if(pos < 0) {
          pos = this.galleryData.length - 1
        }
        else if (pos >= this.galleryData.length) {
          pos = 0;
        }
      }
      this.artist = await this.$store.dispatch('fetchArtistById', this.galleryData[pos].artist_id)
      this.selImage = this.galleryData[pos].images[0]
    },
    async init () {
      this.loaded = false
      this.items = []
      if(!this.gallery) return
      if(this.gallery.gallery_id){
        let gd = await this.$store.dispatch('fetchGalleryData', this.gallery.gallery_id)
        if(gd) {
          await this.$store.dispatch('fetchArtists')
          let artists = this.$store.getters.nonExcludedArtists.filter(el => el.artist_id)
          let lang = this.$store.state.lang.toLowerCase()
          artists = artists.filter(el => { return  !el.hiddens.includes(lang) })
          
          gd = gd.filter(el => artists.find(al => al.artist_id === el.artist_id))
          gd.sort((el, el1) => { return el.rnd - el1.rnd })
          gd = gd.slice(0, 8)
          this.galleryData = gd
          let items = []
          for(let each of gd) {
            items.push({ data: each, style: true, key: 'style-' + each.artist_id})
          }
          let res = await this.$apix.get('news/bytag/' + this.tag)
          let articles = res.data.slice(0,4)
          items.splice(2, 0, { data: articles[0], style: false, key: 'news-' + articles[0].news_id })
          items.splice(5, 0, { data: articles[1], style: false, key: 'news-' + articles[1].news_id })
          items.splice(8, 0, { data: articles[2], style: false, key: 'news-' + articles[2].news_id })
          items.splice(11, 0, { data: articles[3], style: false, key: 'news-' + articles[3].news_id })
          this.items = items;
          this.galStyleLink = this.$nippets.replace('homeAnim.moreStyle', 'gallery', this.gallery.name.toLowerCase())
          this.loaded = true
        }
      }
    },
    goStory (item) {
      this.$ixr.push(item.permalink)
    },
    showZoomPortfolio: async function (item) {
      this.artist = item.artist
      this.selImage = item.image
      this.showZoom = true
    },
    goPortfolio: async function (artist) {
      this.$ixr.push('/animators/' + artist.portfolio_url)
    },
    closeZoom: function () {
      this.showZoom = false
    }
  },
  watch: {
    gallery() {
      this.init ()
    }
  }
}
</script>

<style scoped>
.style-news-area{
  display:grid;
  grid-template-columns: calc(33.3% - 10px) calc(33.3% - 10px) calc(33.3% - 10px);
  grid-gap:15px;
}

.pt-16{
  padding-top:16px;
}

.t-right{
  text-align:right;
}

.style-news-headers{
  display:grid;
  grid-template-columns: calc(33.3% - 10px) calc(33.3% - 10px) calc(33.3% - 10px);
  grid-gap:15px;
}

.stnh-wide{
  grid-column: 1 / 3;
}

.style-news-area .imdiv{
  position:relative;
}

.style-news-headers h3{
  color: #101820;
  font-size: 33px;
  margin-top: 0;
  margin-bottom:16px;
}
</style>